import type { StakeholderRatings } from '@bandos/shared'

export function calculateAverageRating(ratings: StakeholderRatings): number | null {
  if (ratings.stakeholders.length === 0) return null
  const sum = ratings.stakeholders.reduce((acc, rating) => acc + rating.rating, 0)
  return Math.round((sum / ratings.stakeholders.length) * 10) / 10
}
